import { useContext } from "react";
import { Box } from "@mui/material";
import { HeadingText, ParagraphText, UBButton } from "../../../Libraries";
import { TitleAndActionBox } from "../../common";
import { PoweredRupinIcon } from "../../../assets/icons/icon";
import { LanguageContext } from "../../../context/LanguageContext";
import { formatNum } from "../../../oscar-pos-core/constants";
import useIsMobile from "../../../hooks/useIsMobile";
import styles from "./styles.module.css";

const UCashTransactionReceipt = ({
  amount = 0,
  headerText = "",
  recipientName = "",
  customerName = "",
  bankInfo = "",
  rows = [],
  onBack,
  onPrint,
  isPrintLoading = false,
  onCopy,
  onDownload,
  isDownloadLoading = false,
  title,
  packageName
}) => {
  const [I18n] = useContext(LanguageContext);
  const isMobile = useIsMobile();

  return (
    <Box className={styles.wrapper}>
      <TitleAndActionBox
        data={{
          title: title || I18n.receipt,
          isBack: true,
          onBack,
          id: "receipt_details",
        }}
      />

      <Box className={styles.contentShell}>
        <Box className={styles.contentShellInner}>
          <Box className={styles.contentColumn}>
            <Box className={styles.card}>
              {headerText ? (
                <Box className={styles.cardHeader}>
                  <ParagraphText className={`fontSize14 ${styles.cardHeaderText}`} dir="auto">
                    {headerText}
                  </ParagraphText>
                </Box>
              ) : null}

              <Box className={styles.cardAmountContainer}>
                <HeadingText tag="h2" className={styles.cardAmount}>
                  Rs. {formatNum(amount)}
                </HeadingText>

                {customerName ? (
                  <ParagraphText className={`fontSize14 ${styles.cardRecipient}`}>
                    {customerName}
                  </ParagraphText>
                ) : null}

                {recipientName ? (
                  <ParagraphText className={`fontSize14 ${styles.cardRecipient}`}>
                    {recipientName}
                  </ParagraphText>
                ) : null}

                {bankInfo ? (
                  <ParagraphText className={`fontSize14 ${styles.cardBank}`}>
                    {bankInfo}
                  </ParagraphText>
                ) : null}
                {packageName ? (
                  <ParagraphText className={`fontSize14 ${styles.cardBank}`}>
                    {packageName}
                  </ParagraphText>
                ) : null}
              </Box>

              <Box className={styles.detailsSection}>
                {rows.map((row, i) => (
                  <Box
                    key={i}
                    className={`${styles.row} ${
                      i === rows.length - 1 ? styles.rowLast : ""
                    }`}
                  >
                    <ParagraphText className={`fontSize14 ${styles.rowLabel}`}>
                      {row.label}
                    </ParagraphText>
                    <ParagraphText className={`fontSize14 ${styles.rowValue}`}>
                      {row.value}
                    </ParagraphText>
                  </Box>
                ))}
              </Box>

              <Box className={styles.poweredBy}>
                <PoweredRupinIcon />
              </Box>
            </Box>

            <Box className={styles.bottomBar}>
              {onDownload && (isMobile || !onCopy) ? (
                <UBButton
                  id="receipt_download_btn"
                  title={I18n.download_recipt}
                  className={`ubSecondaryButton textUppercase ${styles.printBtn}`}
                  loading={isDownloadLoading}
                  disabled={isDownloadLoading}
                  onClick={onDownload}
                />
              ) : null}
              {!isMobile && onCopy ? (
                <UBButton
                  id="receipt_copy_btn"
                  title={I18n.copy_receipt}
                  className={`ubSecondaryButton textUppercase ${styles.printBtn}`}
                  onClick={onCopy}
                />
              ) : null}
              {onPrint ? (
                <UBButton
                  id="receipt_print_btn"
                  title={I18n.print_receipt}
                  className={`ubPrimaryButton textUppercase ${styles.printBtn}`}
                  loading={isPrintLoading}
                  disabled={isPrintLoading}
                  onClick={onPrint}
                />
              ) : null}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default UCashTransactionReceipt;
